module.exports = __webpack_public_path__ + "img/introduce05_right04.da9390e6.png";